import type {
  TrackingEvent,
  TrackingEventName,
  TrackingService,
} from "./TrackingApi";
import { VisitorConsent, onVisitorConsent } from "./consent-api";

export class NotifyApi implements TrackingService {
  host: string;
  eventNames: Map<TrackingEventName, string>;

  shop: string;
  sessionId?: string;
  customerId?: string;
  #visitorConsent?: VisitorConsent;

  constructor({
    host,
    shop,
    sessionId,
    customerId,
  }: {
    host: string;
    shop: string;
    sessionId?: string;
    customerId?: string;
  }) {
    this.host = host;
    this.shop = shop;
    this.customerId = customerId;
    this.sessionId = sessionId;

    this.eventNames = new Map([
      ["viewWishlist", "wishlist_viewed"],
      ["addToCart", "product_added_to_cart"],
      ["shareWishlist", "wishlist_shared"],
    ]);

    onVisitorConsent((visitorConsent) => {
      this.#visitorConsent = visitorConsent;
    });
  }

  setSession(sessionId: string) {
    this.sessionId = sessionId;
  }

  clearSession() {
    this.sessionId = undefined;
  }

  async track({
    eventName,
    wishlist,
    product,
    variant,
    quantity,
    source,
  }: TrackingEvent) {
    if (!this.sessionId && !this.customerId) {
      return false;
    }

    const eventAction = this.eventNames.get(eventName);
    if (!eventAction || !wishlist) {
      return false;
    }

    return window
      .fetch(this.host + `/notify`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-appmate-shp": this.shop,
          "x-appmate-sid": this.sessionId ?? "",
          "x-appmate-cid": this.customerId ?? "",
        },
        body: JSON.stringify({
          event: eventAction,
          wid: wishlist.publicId,
          pid: product?.id,
          vid: variant?.id,
          qty: quantity,
          src: source,
        }),
      })
      .then(() => true)
      .catch((error) => false);
  }

  getQuerystring(query?: Record<string, any>) {
    if (!query) {
      return "";
    }

    const params = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((value) => params.append(key, value));
      } else if (value) {
        params.append(key, value);
      }
    });

    return "?" + params.toString();
  }
}
